import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Card, CardBody, Progress, Table } from 'reactstrap';
import NoDataDashboard from '../../components/NoDataDashboard';
import Loader from '../../components/Loader';
import AxiosContext from '../../helpers/AxiosContext';

const ProgressBar = ({ label, value, color }) => (
    <div className="mt-2" style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ backgroundColor: color, width: '10px', height: '10px', borderRadius: '50%' }}></div>
        <b className="ml-2 mr-3" style={{ color: 'gray' }}>
            {label}
        </b>
        <span style={{ color: '#1e1d1d' }}>{value}</span>
    </div>
);

const RepositoryIssuesListOverview = (props) => {
    const axios_api = useContext(AxiosContext).axios;
    const [repositoriesList, setRepositoriesList] = useState([]);
    const [loading, setLoading] = useState(true);

    const getVulnerabilitiesByRepos = async () => {
        
        let res = await axios_api.get('scan/vulnerabilities/repository-list').catch((e) => {
            console.error(e);
        });

        if (res) {
            setRepositoriesList(res.data);
        }

        setLoading(false);
    };

    useEffect(() => {
        getVulnerabilitiesByRepos();
    }, []);

    if (loading) {
        return <Loader />;
    }

    if (repositoriesList.length === 0) {
        return <NoDataDashboard />;
    }

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <Table>
                        <thead>Issues By Repositories</thead>
                        <tbody>
                            {Object.keys(repositoriesList).map((name, idx) => {
                                const stats = repositoriesList[name];
                                let total = 0;
                                const critical = stats['Critical'];
                                const high = stats['High'];
                                const medium = stats['Medium'];
                                const low = stats['Low'];
                                const informational = stats['Informational'];
                                Object.keys(stats).map((key, idx) => {
                                    total += stats[key];
                                });
                                return (
                                    <tr key={idx}>
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <h5>
                                                    <b>{name}</b>
                                                </h5>
                                                <h5 className="ml-2" style={{ color: 'gray' }}>
                                                    {total} issues found
                                                </h5>
                                            </div>
                                            <div>
                                                <Progress className="mt-2" multi>
                                                    {critical && 
                                                        <Progress
                                                            style={{ backgroundColor: '#ff5c75' }}
                                                            max={total}
                                                            bar
                                                            value={critical}
                                                        />
                                                    }
                                                    {high && 
                                                        <Progress
                                                            style={{ backgroundColor: 'orange' }}
                                                            max={total}
                                                            bar
                                                            value={high}
                                                        />
                                                    }
                                                    {medium && 
                                                        <Progress
                                                            style={{ backgroundColor: '#ffbe0b' }}
                                                            max={total}
                                                            bar
                                                            value={medium}
                                                        />
                                                    }
                                                    {low && 
                                                        <Progress
                                                            style={{ backgroundColor: '#25c2e3' }}
                                                            max={total}
                                                            bar
                                                            value={low}
                                                        />
                                                    }
                                                    {informational && 
                                                        <Progress
                                                            style={{ backgroundColor: '#43d39e' }}
                                                            max={total}
                                                            bar
                                                            value={informational}
                                                        />
                                                    }
                                                </Progress>
                                            </div>
                                            <div>
                                                {critical && 
                                                    <ProgressBar label="Critical" value={critical} color="#ff5c75" />
                                                }
                                                {high && 
                                                    <ProgressBar label="High" value={high} color="orange" />
                                                }
                                                {medium && 
                                                    <ProgressBar label="Medium" value={medium} color="#ffbe0b" />
                                                }
                                                {low && 
                                                    <ProgressBar label="Low" value={low} color="#25c2e3" />
                                                }
                                                {informational && 
                                                    <ProgressBar label="Informational" value={informational} color="#43d39e" />
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>

                    <div>
                        The total count include issues for the categories:{' '}
                        <Link to="vulnerabilities/details?category=Repository">Repository</Link>{', '} 
                        <Link to="vulnerabilities/details?category=Secrets">Secrets</Link>{', '}
                        <Link to="vulnerabilities/details?category=Dependency Issues">Dependency Issues</Link>{', '}
                        <Link to="vulnerabilities/details?category=Dependency Licenses">Dependency Licenses</Link>
                    </div>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default RepositoryIssuesListOverview;
